module.exports = __webpack_public_path__ + "static/media/icon.5922d25b.gif";